import * as React from 'react';
import { getMagazinePageSectionTypes } from 'helpers/pagesections';
import { Modal, Button } from 'components';
import { IDropdownData } from 'models/common';
import { IModalAction } from 'models/modal';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { PortalPageSection, ButtonsSection } from 'components/PortalStructure';
require('./style.css');

interface IProps {
	addSection?: (sectionType: string) => void;
	closeModal: Redux.ActionCreator<IModalAction>;
	showHeaderCloseButton: boolean;
	t?: (key: string) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class MagazinePageSectionSelector extends React.Component<IProps, any> {
	private selectedTypeKey = '';

	constructor(props) {
		super(props);

		this.selectedTypeKey = '';
		this.onTypeChange = this.onTypeChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.cancelClick = this.cancelClick.bind(this);
	}

	private onTypeChange(event: any) {
		this.selectedTypeKey = event.target.value;
		this.forceUpdate();
	}

	public onSubmit() {
		const { t } = this.props;
		if (!this.selectedTypeKey) {
			alert(t('Magazine_SectionSelector_Validation'));
			return;
		}
		this.props.addSection(this.selectedTypeKey);
	}

	private cancelClick() {
		this.props.closeModal();
	}

	public render() {
		const { t, showHeaderCloseButton, closeModal } = this.props;
		const sectionTypes: IDropdownData[] = getMagazinePageSectionTypes();
		const radioButtonInputs = sectionTypes.map((item: IDropdownData) => {
			return (
				<div key={item.key} className="col-sm-4" title={t(item.value)}>
					<div className="sectionSelector__item">
						<p>{t(item.value)}</p>
						<label>
							<input
								key={item.key}
								type="radio"
								name="articleId"
								value={item.key}
								onChange={this.onTypeChange}
								checked={item.key === this.selectedTypeKey}
							/>
							<img src={require(`containers/Html/images/landingpage/${item.image || item.value}`)} />
						</label>
					</div>
				</div>
			);
		});

		return (
			<Modal
				title={t('Magazine_ArticleCategory_Page_SectionSelector_NewSection')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				modalClass="sectionSelectorContainer"
			>
				<PortalPageSection usage="admin">
					<div className="row sectionSelectorItemsWrapper">{radioButtonInputs}</div>
				</PortalPageSection>
				<ButtonsSection>
					<div className="row">
						<div className="col-sm-12">
							<Button onClick={this.onSubmit} usage="admin">
								{t('BSPortal_Common_Continue')}
							</Button>
						</div>
					</div>
				</ButtonsSection>
			</Modal>
		);
	}
}

export { MagazinePageSectionSelector };
